export const MODULE_TYPE = {
  RULE: 1, // 右上角Rules
  DETAIL: 2, // 累计已省模块
  BUY_BUTTON: 3, // 会员权益购买按钮
  PACKAGING: 4, // 加量包购买模块
  UPGRADE_BUTTON: 5, // 5-特型页面“开启订阅”按钮
};

export const PAY_STATUS = {
    SUCCESS:1,
    CLOSE:2,
    CANCEL:3
}

export const POP_DIALOG_POSITION = {
    MEMBER: 9
}

export const HISTORY_PAGE = '/${locale}/memberHistory'
export const OLD_PACK_PAGE = "/${locale}/oldMember";

export const DIDI_FOOD_BRAND = 'DiDi Food'

export const SCENE = {
    RENEW:1,
    RECOMMEND:2,
    ASSIGN:3
}

export const SALE_CHANNEL = 21 // 21表示独立页购买
export const UPGRADES_CHANNEL = 22; // 22表示独立页升级

export const DIDI_PRO = "DiDi Pro";
export const DIDI_PACK = "DiDi Pack";

export const BACK_ICON_NAME = "icon-v3_outlined_back";

export const COUPON_URL_DIDI = 'https:\/\/c-h5.didi-food.com\/${locale}\/user\/validCouponInfo?nativeWebUIType=2' // eslint-disable-line

export const BUY_COUPON_PACKAGE = 1 // 已经开通购买会员

// 服务端
// 1-免配 
// 2-免服务费 
// 3-其它权益 
// 4-出行券 
// 5-生日权益  
// 6-商家券

// 埋点
// 6-免配权益点击
// 7-免服务费权益点击
// 8-会员商家券权益点击
// 9-5%off出行权益点击
// 10-生日券权益点击
// 11-其他权益点击

// 81-会员商家券权益详情浮层内跳转按钮点击
// 91-出行权益详情浮层内跳转按钮点击
// 111-其他权益详情浮层内跳转按钮点击
export const BENEFIT_OPEN_DIALOG_TYPE = {
  1: 6,
  2: 7,
  3: 11,
  4: 9,
  5: 10,
  6: 8,
};

export const BENEFIT_JUMP_TYPE = {
  6: 81,
  4: 91,
  3: 111,
};

export const DELIVERY_BENEFIT = 4 // 出行权益

export const GLOBAL_EMBED_CUSTOMER = 7 // 国际嵌入式C端 

export const IS_FIRST_ENTRY = "isFirstEntry"; // 第一次进入app
 